<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" @input="getList" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
            @input="getList"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="lineTable"
          title="LINE 목록"
          :columns="gridline.columns"
          :data="gridline.data"
          :columnSetting="false"
          :isFullScreen="false"
          :editable="editable"
          :usePaging="false"
          :expandAll="true"
          :filtering="false"
          :isExcelDown="false"
          rowKey="lineId"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="추가" icon="add" @btnClicked="addLine" v-if="editable" />
              <!-- <c-btn label="삭제" icon="remove" @btnClicked="removeLine" v-if="editable" /> -->
              <c-btn label="저장" icon="save" @btnClicked="saveLine" v-if="editable" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="placeTable"
          title="장소(층) 목록"
          :columns="gridplace.columns"
          :data="gridplace.data"
          :columnSetting="false"
          :isFullScreen="false"
          :editable="editable"
          :usePaging="false"
          :expandAll="true"
          :filtering="false"
          :isExcelDown="false"
          rowKey="placeId"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="추가" icon="add" @btnClicked="addPlace" v-if="editable" />
              <!-- <c-btn label="삭제" icon="remove" @btnClicked="removePlace" v-if="editable" /> -->
              <c-btn label="저장" icon="save" @btnClicked="savePlace" v-if="editable" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'process-manage',
  data() {
    return {
      lineListUrl: '',
      lineSaveUrl: '',
      placeListUrl: '',
      placeSaveUrl: '',
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
      },
      gridline:  {
        columns: [
          {
            required: true,
            name: 'plantCd',
            field: 'plantCd',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width:200px',
            type: 'plant',
          },
          {
            required: true,
            name: 'lineCd',
            field: 'lineCd',
            label: '라인명',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            align: 'center',
            style: 'width:100px',
            type: 'number',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width:100px',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
        ],
        data: [],
      },
      gridplace:  {
        columns: [
          {
            required: true,
            name: 'plantCd',
            field: 'plantCd',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width:200px',
            type: 'plant',
          },
          {
            required: true,
            name: 'placeName',
            field: 'placeName',
            label: '장소(층)',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            align: 'center',
            style: 'width:100px',
            type: 'number',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            style: 'width:100px',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: false,
      deletable: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.lineListUrl = selectConfig.mdm.line.list.url;
      this.lineSaveUrl = transactionConfig.mdm.line.save.url;
      this.placeListUrl = selectConfig.mdm.place.list.url;
      this.placeSaveUrl = transactionConfig.mdm.place.save.url;
      this.getList();
    },
    getList() {
      this.getLineList();
      this.getPlaceList();
    },
    getLineList() {
      this.$http.url = this.lineListUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.gridline.data = _result.data;
      },);
    },
    saveLine() {
      let checkItem = ['plantCd','lineCd', 'sortOrder']
      let isConti = true;
      this.$_.forEach(this.gridline.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [사업장, 라인번호, 순번]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.gridline.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.lineSaveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.getLineList();
                window.getApp.$emit('ALERT', {
                  title: '안내 ', /* 안내 */
                  message: '저장되었습니다.', /* 저장되었습니다. */
                  type: 'success', // success / info / warning / error
                });
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    addLine() {
      this.gridline.data.push({
        editFlag: 'C',
        plantCd: this.searchParam.plantCd ? this.searchParam.plantCd : null,
        lineId: '',
        lineCd: '',
        sortOrder: (this.gridline.data.length + 1) * 10,
        useFlag: 'Y',
        regUserId: this.$store.getters.user.userId
      })
    },
    removeLine() {
      let selectData = this.$refs['lineTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (selectData[0].editFlag !== 'C') {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '행추가 후 저장되지 않은 데이터만 삭제됩니다.', // 하나 이상 선택하세요.
            type: 'warning', // success / info / warning / error
          });
          this.$refs['lineTable'].$refs['compo-table'].clearSelection();
        } else {
          this.$_.forEach(selectData, item => {
            if (item.editFlag === 'C') {
              this.gridline.data = this.$_.reject(this.gridline.data, item);
            }
          })
          this.$refs['lineTable'].$refs['compo-table'].clearSelection();
        }
      }
    },
    getPlaceList() {
      this.$http.url = this.placeListUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.gridplace.data = _result.data;
      },);
    },
    savePlace() {
      let checkItem = ['plantCd','placeName', 'sortOrder']
      let isConti = true;
      this.$_.forEach(this.gridplace.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [사업장, 장소(층), 순번]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.gridplace.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.placeSaveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.getPlaceList();
                window.getApp.$emit('ALERT', {
                  title: '안내 ', /* 안내 */
                  message: '저장되었습니다.', /* 저장되었습니다. */
                  type: 'success', // success / info / warning / error
                });
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    addPlace() {
      this.gridplace.data.push({
        editFlag: 'C',
        plantCd: this.searchParam.plantCd ? this.searchParam.plantCd : null,
        placeId: '',  // 장소일련번호
        placeName: '',  // 장소명
        sortOrder: (this.gridplace.data.length + 1) * 10,
        useFlag: 'Y',
        regUserId: this.$store.getters.user.userId
      })
    },
    removePlace() {
      let selectData = this.$refs['placeTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (selectData[0].editFlag !== 'C') {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '행추가 후 저장되지 않은 데이터만 삭제됩니다.', // 하나 이상 선택하세요.
            type: 'warning', // success / info / warning / error
          });
          this.$refs['placeTable'].$refs['compo-table'].clearSelection();
        } else {
          this.$_.forEach(selectData, item => {
            if (item.editFlag === 'C') {
              this.gridplace.data = this.$_.reject(this.gridplace.data, item);
            }
          })
          this.$refs['placeTable'].$refs['compo-table'].clearSelection();
        }
      }
    },
  }
};
</script>
